type RegularListProps<T> = {
  items: T[];
  itemComponent: any;
  resoucreName: string;
  keyExtractor: (item: T) => string | number;
  extraData?: Record<string, unknown>;
};

export default function RegularList<T>({
  items,
  resoucreName,
  itemComponent: ItemComponent,
  keyExtractor,
  extraData = {},
}: RegularListProps<T>) {
  return (
    <>
      {items.length !== 0 &&
        items.map((item) => (
          <ItemComponent
            key={keyExtractor(item)}
            {...extraData}
            {...{ [resoucreName]: item }}
          />
        ))}
    </>
  );
}
